export default class SurveyDaysAdditionalDetailsViewModel {
    weatherAm: string | null = null;
    weatherPm: string | null = null;
    initialOccupancy: number | null = null;
    finalOccupancy: number | null = null;
    parkingCapacity: string | null = null;
    onSiteSpaces: string | null = null;
    ogv1Percentage: number | null = null;
    ogv2Percentage: number | null = null;
    motorCarPercentage: number | null = null;
    motorCyclePercentage: number | null = null;
    publicServicePercentage: number | null = null;
    lightGoodsPercentage: number | null = null;
    taxisPercentage: number | null = null;
    servicingVehiclesRecorded: string | null = null;
    ogv1Vehicle: number | null = null;
    ogv2Vehicle: number | null = null;
    lightGoodsVehicle: number | null = null;
    motorCarVehicle: number | null = null;
    motorCycleVehicle: number | null = null;
    ogv1Servicing: number | null = null;
    ogv2Servicing: number | null = null;
    lightGoodsServicing: number | null = null;
    motorCarServicing: number | null = null;
    motorCycleServicing: number | null = null;
    ogv1Standard: number | null = null;
    ogv2Standard: number | null = null;
    lightGoodsStandard: number | null = null;
    motorCarStandard: number | null = null;
    motorCycleStandard: number | null = null;
    comment: string | null = null;

    multiModalOveride: boolean | null = null;
}